var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"100%"}},[_c('WujieVue',{staticClass:"item",attrs:{"name":"demo-vue2","url":_vm.vue2Url,"sync":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }